<template>
  <div class="app-transfer-wrapper">
    <div class="app-list-container">
      <div class="header">
        <el-checkbox
          v-model="allChecked"
          :indeterminate="isIndeterminate"
          @change="onAllCheckChange" >
          可用应用（默认选择第一个套餐）
        </el-checkbox>
        <span>{{ checkSummary() }}</span>
      </div>

      <div class="app-list">
        <div v-for="(option, index) in options"
          :key="option.app_store_id"
          :class="[
            'app-item',
            showingOptionIndex === index ? 'active' : ''
          ]"
          @click="onAppItemClick(index)" >
          <el-checkbox v-model="option.form.checked" @change="onAppCheckChange" />
          <span style="margin-left: 10px">{{ getOptionLabel(option) }}</span>
        </div>
      </div>
    </div>

    <div class="form-container" v-if="options.length > 0">
      <div class="header">
        <el-checkbox
          @change="onAppCheckChange"
          v-model="options[showingOptionIndex].form.checked">
          是否启用应用：{{ options[showingOptionIndex].app_name_i18n[0].name }}
        </el-checkbox>
      </div>

      <div class="form">

        <div class="form-item">
          <p class="label">套餐</p>
          <el-radio-group
            v-model="options[showingOptionIndex].form.packageIndex" >
            <el-radio
              v-for="(pac, index) in options[showingOptionIndex].package"
              :key="index"
              :label="index">
              {{ getPackageLabel(pac) }}
            </el-radio>
          </el-radio-group>
        </div>

        <div class="form-item">
          <p class="label">是否启用扩展字段</p>
          <el-radio-group @change="onExtendEnableChange"
              v-model="options[showingOptionIndex].form.enableExtend">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </div>

        <div class="form-item"
          v-if="options[showingOptionIndex].form.enableExtend &&
            appExtendParamList.length > 0">
          <p class="label">扩展字段</p>
          <div class="extend-param"
            v-for="(extend, index) in options[showingOptionIndex].form.extend"
            :key="extend.name + index" >
            <el-select
              style="width: 40%; margin-bottom: 10px;"
              v-model="extend.name"
              @change="onExtendChange(index, $event)">
              <el-option
                v-for="extend in appExtendParamList"
                :key="extend.extend_param_id"
                :value="extend.extend_param_name" >
                {{ extend.extend_param_name }}
              </el-option>
            </el-select>
            <el-input
              style="width: 40%; margin-left: 30px;"
              v-model="extend.value"
              placeholder="请输入扩展字段的值" />
            <el-input
              style="width: 40%;"
              v-model="extend.remarks"
              placeholder="请输入扩展字段的备注" />
            <el-button
              type="danger"
              size="medium"
              style="margin-left: 30px;"
              @click="onDeleteExtendClick(index)">删除</el-button>
          </div>
        </div>

        <div class="form-item" v-if="options[showingOptionIndex].form.enableExtend">
          <el-button
            type="danger"
            size="medium"
            @click="onAddExtendClick">添加扩展字段</el-button>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AppTransfer',
  props: {
    appList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      allChecked: false,
      isIndeterminate: false,

      options: [],
      showingOptionIndex: 0,
      lastFetchExtendAppId: 0
    }
  },
  computed: {
    ...mapState('store', [
      'appExtendParamList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'adddUserApps',
      'getAppExtendParams'
    ]),

    onAllCheckChange (checked) {
      this.options.forEach(option => {
        option.form.checked = checked
      })
      this.isIndeterminate = false
    },
    checkSummary () {
      return `${this.checkedCount()}/${this.options.length}`
    },
    checkedCount () {
      let count = 0
      this.options.forEach(option => {
        if (option.form.checked) {
          count++
        }
      })
      return count
    },
    generateOptions () {
      // 重置数据
      this.showingOptionIndex = 0
      this.options.splice(0, this.options.length)
      this.allChecked = false
      this.isIndeterminate = false
      this.lastFetchExtendAppId = 0

      // console.log(this.appList)
      this.appList.forEach(app => {
        const option = JSON.parse(JSON.stringify(app))
        option.form = {
          checked: false,
          packageIndex: 0,
          enableExtend: false,
          extend: []
        }

        this.options.push(option)
      })
    },
    getOptionLabel (option) {
      const appName = option.app_name_i18n[0].name
      if (option.form.checked) {
        const packageName = option.package[option.form.packageIndex].name
        const extendCount = option.form.extend.length

        if (extendCount > 0) {
          return `${appName}（套餐：${packageName}，扩展字段：${extendCount}个）`
        } else {
          return `${appName}（套餐：${packageName}）`
        }
      } else {
        return appName
      }
    },
    getPackageLabel (pac) {
      const expireTime = this.$options.filters['expire'](pac.duration)
      return `${pac.name} (${expireTime})`
    },
    onAppItemClick (index) {
      this.showingOptionIndex = index
    },
    onAppCheckChange () {
      const checkedCount = this.checkedCount()
      const appCount = this.options.length

      if (checkedCount === 0) {
        this.isIndeterminate = false
        this.allChecked = false
      } else if (checkedCount === appCount) {
        this.isIndeterminate = false
        this.allChecked = true
      } else {
        this.isIndeterminate = true
      }
    },

    async onExtendEnableChange (checked) {
      const currentOption = this.options[this.showingOptionIndex]

      if (checked) {
        // 获取应用可用的扩展参数
        await this.checkAndRetriveExtends()

        if (this.appExtendParamList.length === 0) {
          this.$message({
            type: 'error',
            message: '当前应用不支持扩展字段'
          })
          return
        }

        // 将当前应用所有的扩展字段添加到应用当中
        currentOption.form.extend = []
        this.appExtendParamList.forEach(extend => {
          currentOption.form.extend.push({
            name: extend.extend_param_name,
            value: '',
            remarks: extend.remarks
          })
        })
      } else {
        // 将当前应用所有的扩展字段删除
        currentOption.form.extend = []
      }
    },
    async onAddExtendClick () {
      const currentOption = this.options[this.showingOptionIndex]
      await this.checkAndRetriveExtends()

      if (this.appExtendParamList.length === 0) {
        this.$message({
          type: 'error',
          message: '当前应用不支持扩展字段'
        })
        return
      } else if (currentOption.form.extend.length >= this.appExtendParamList.length) {
        this.$message({
          type: 'error',
          message: '已添加当前应用的所有扩展字段'
        })
        return
      }
      const addingExtend = this.appExtendParamList[currentOption.form.extend.length]
      currentOption.form.extend.push({
        name: addingExtend.extend_param_name,
        value: '',
        remarks: addingExtend.remarks
      })
    },
    // 检查并获取应用扩展字段
    async checkAndRetriveExtends () {
      try {
        const currentOption = this.options[this.showingOptionIndex]
        // 如果当前应用刚获取了扩展字段，则不做重复请求
        if (this.lastFetchExtendAppId !== currentOption.app_store_id) {
          await this.getAppExtendParams({
            page: 1,
            pageSize: 9999,
            condition: {
              app_store_id: currentOption.app_store_id
            }
          })
          this.lastFetchExtendAppId = currentOption.app_store_id
        }
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取应用扩展字段失败'
        })
      }
    },
    // 删除扩展字段
    onDeleteExtendClick (index) {
      this.options[this.showingOptionIndex].form.extend.splice(index, 1)
    },
    onExtendChange (index, selected) {
      this.appExtendParamList.forEach(extend => {
        if (extend.extend_param_name === selected) {
          this.options[this.showingOptionIndex].form.extend[index].remarks = extend.remarks
        }
      })
    },
    getPickedApps () {
      const pickedAppList = []
      this.options.forEach(option => {
        if (option.form.checked) {
          const pickedApp = {
            app_store_id: option.app_store_id,
            extend: [],
            duration: option.package[option.form.packageIndex].duration
          }

          if (option.form.enableExtend) {
            option.form.extend.forEach(extend => {
              if (extend.name === '' || extend.value === '' || extend.remarks === '') {
                this.$message({
                  type: 'error',
                  message: '请填写所有扩展字段的信息'
                })

                const err = {
                  msg: 'empty extend field',
                  code: -1
                }
                throw err
              }
              pickedApp.extend.push({
                name: extend.name,
                value: extend.value,
                remarks: extend.remarks
              })
            })
          }

          pickedAppList.push(pickedApp)
        }
      })
      return pickedAppList
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.app-transfer-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .app-list-container {
    border: 1px solid #ebeef5;
    border-radius: 5px;
    width: 350px;

    .header {
      background: #f5f7fa;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .app-list {
      height: 350px;
      overflow-y: scroll;

      .app-item {
        padding: 0 10px;
        cursor: pointer;

        &.active {
          color: $primaryColor;
          background: #f5f7fa;
        }
        &:hover {
          background: #f5f7fa;
        }
      }
    }
  }

  .form-container {
    border: 1px solid #ebeef5;
    border-radius: 5px;
    width: 600px;
    margin-left: 25px;

    .header {
      background: #f5f7fa;
      padding: 10px;
    }

    .form {
      height: 350px;
      overflow-y: scroll;

      .label {
        margin: 0;
      }
      .form-item {
        padding: 10px;

        .extend-param {
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          margin-bottom: 10px;
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/AppTransfer.vue